import { render, staticRenderFns } from "./HeaderForFooter.vue?vue&type=template&id=4ee554a5&scoped=true&"
import script from "./HeaderForFooter.vue?vue&type=script&lang=js&"
export * from "./HeaderForFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeaderForFooter.vue?vue&type=style&index=0&id=4ee554a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee554a5",
  null
  
)

export default component.exports